import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import TableStateCard from '../components/TableStateCard';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { getTextColorClassStock, convertToMoney } from '../utils/formats';
import { getProviders } from '../utils/functions';
import { getSelectedBranchId } from '../utils/branch';
import { navigateTo } from '../utils/navigation';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import StockAdjustModal from './StockAdjustModal';

var config = process.env;
const PRODUCT_TYPE = {
    1: 'Juego',
    2: 'Accesorio',
};

class TableProductsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'name',
            sortDir: 'asc',
            data: [],
            loaded: false,
            providers: {},
            selectedProductType: this.normalizeProductType(this.props.productTypeFilter),
            // Producto cuyo stock se está ajustando (null = modal cerrado).
            adjusting: null,
        };
    }

    normalizeProductType = (value) => {
        const normalizedValue = Number(value);
        return normalizedValue === 1 || normalizedValue === 2 ? normalizedValue : '';
    }

    getActiveProductType = () => {
        if (this.props.productTypeFilter != null) {
            return this.normalizeProductType(this.props.productTypeFilter);
        }

        return this.normalizeProductType(this.state.selectedProductType);
    }

    async componentDidMount() {
        this.fetchData();
        try {
            let providers = await getProviders('product');
            let providersDic = {};
            providers.forEach((provider) => {
                providersDic[provider.providerId] = provider.name;
            });
            this.setState({ providers: providersDic });
        } catch (error) {
            console.error('No se pudieron cargar los proveedores de productos:', error);
            this.setState({ providers: {} });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productTypeFilter !== this.props.productTypeFilter) {
            this.setState({ selectedProductType: this.normalizeProductType(this.props.productTypeFilter) });
            this.fetchData({ page: 1 });
        }
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const selectedBranchId = getSelectedBranchId();
        const baseUrl = selectedBranchId && selectedBranchId !== 'all'
            ? `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/${selectedBranchId}/product`
            : `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}product`;
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            extraParams: {
                branchId: selectedBranchId || undefined,
                productType: this.getActiveProductType() || undefined,
            },
        });

        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        fetch(`${baseUrl}?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true
                });
            }
        })
        .catch((error) => {
            console.error('No se pudieron cargar los productos:', error);
            this.setState({
                data: [],
                totalItems: 0,
                loaded: true
            });
        });
    }

    createModals = () => {
        if (!this.state.loaded) {
            return null;
        }

        return (
            <div>
                {this.state.data.map((data) => this.createModalRemove(data.code, data.prefix, data.name))}
            </div>
        );
    }

    createModalRemove = (code, prefix, name) => {
        return (
            <div className="modal fade" id={`modal-remove-${code}`} role="dialog" key={code}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{ textAlign: 'center' }}>Eliminar</h4>
                        </div>
                        <div className="modal-body">
                            <p>¿Estás seguro que deseas eliminar el producto?</p>
                            <p style={{ marginBottom: '7px' }}><b>Código:</b> {prefix}{code}</p>
                            <p><b>Nombre:</b> {name}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm"
                                data-dismiss="modal">
                                Cancelar
                            </button>
                            <button
                                className="mb-2 mr-1 btn btn-primary btn-sm"
                                data-dismiss="modal"
                                onClick={() => this.onDeleteItem(code)}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    drawRow = (item, index) => {
        const finalPrice = Number.isFinite(Number(item.finalPrice))
            ? Number(item.finalPrice)
            : Number(item.price || 0) * (1 - (Number(item.discount || 0) / 100));

        return (
            <tr role="row" className="odd" key={item.code} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{item.prefix}{item.code}</td>
                <td>{item.name}</td>
                <td>{PRODUCT_TYPE[item.productType] || 'Producto'}</td>
                <td>$ {convertToMoney(item.price)}</td>
                <td>{item.discount} %</td>
                <td style={{ fontWeight: finalPrice < item.price ? '700' : '500' }}>$ {convertToMoney(finalPrice)}</td>
                <td>{this.state.providers[item.provider] || '-'}</td>
                <td className={getTextColorClassStock(item.stock, item.minStock)}>{item.stock}</td>
                <td>{item.totalStock != null ? item.totalStock : item.stock}</td>
                <td>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        {this.props.role == 1 ? (
                            <button
                                onClick={() => this.onViewAnalytics(item.code)}
                                type="button"
                                className="btn btn-white">
                                <i className="material-icons">insert_chart_outlined</i>
                            </button>
                        ) : null}
                        {/* Ajustar stock: la única puerta que queda para moverlo a mano — el
                            guardado del producto ya no lo toca. Admin-only igual que el endpoint,
                            y con comentario obligatorio adentro del modal. */}
                        {this.props.role == 1 ? (
                            <button
                                onClick={() => this.setState({ adjusting: item })}
                                type="button"
                                title="Ajustar stock"
                                className="btn btn-white">
                                <i className="material-icons">tune</i>
                            </button>
                        ) : null}
                        <button onClick={() => this.onUpdateItem(item.code)} type="button" className="btn btn-white"><i className="material-icons"></i></button>
                        <button
                            style={{ display: this.props.role == 2 ? 'none' : 'table-cell' }}
                            data-toggle="modal"
                            data-target={`#modal-remove-${item.code}`}
                            type="button"
                            className="btn btn-white">
                            <i className="material-icons"></i>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    onDeleteItem = (code) => {
        var request = {
            method: 'DELETE',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code: code })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.fetchData();
            }
        });
    }

    onUpdateItem = (code) => {
        navigateTo(`/editProduct?code=${code}`);
    }

    onViewAnalytics = (code) => {
        navigateTo(`/productAnalytics?code=${code}&source=products`);
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty"><td colSpan="10" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                </td></tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    onChangeProductType = (event) => {
        const selectedProductType = this.normalizeProductType(event.target.value);
        this.setState({ selectedProductType }, () => {
            this.fetchData({ page: 1 });
        });
    }

    renderTypeFilter = () => {
        if (this.props.productTypeFilter != null) {
            return null;
        }

        return (
            <div className="dataTables_filter" style={{ margin: 0 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    Tipo:
                    <select
                        id="select_product_type"
                        className="custom-select custom-select-sm"
                        value={this.state.selectedProductType}
                        onChange={this.onChangeProductType}
                        style={{ minWidth: '160px' }}
                    >
                        <option value="">Todos</option>
                        <option value="1">Juegos</option>
                        <option value="2">Accesorios</option>
                    </select>
                </label>
            </div>
        );
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        const searchActive = hasActiveSearch(this.state.searchInput, this.state.search);

        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        if (this.state.totalItems === 0 && !searchActive) {
            return (
                <TableStateCard
                    icon="inventory"
                    title="Todavia no hay productos para mostrar"
                    message="Cuando existan productos cargados, aca vas a ver precio, proveedor, stock y accesos de gestion."
                />
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div style={{ float: 'right', display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                    {this.renderTypeFilter()}
                    <div id="DataTables_Table_0_filter" className="dataTables_filter" style={{ margin: 0 }}>
                        <label>Search:
                        <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                        </label>
                    </div>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('code')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Código</th>
                            <th {...this.sortableHeader('name')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '22%' }}>Nombre</th>
                            <th {...this.sortableHeader('productType')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Tipo</th>
                            <th {...this.sortableHeader('price')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '12%' }}>Precio</th>
                            <th {...this.sortableHeader('discount')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '12%' }}>Descuento</th>
                            {/* "Precio final" y "Stock total" NO son ordenables: los calcula el backend DESPUÉS
                                de la query (finalPrice sale de precio+descuento por sucursal, totalStock suma
                                las sucursales), no son columnas y el ORDER BY no las conoce. Pedirlas como
                                sortBy caía en el default 'name' sin avisar, así que van sin la clase `sorting`. */}
                            <th aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '12%' }}>Precio final</th>
                            {/* Agrupa por proveedor, pero el backend ordena por el id, no por el nombre que se muestra. */}
                            <th {...this.sortableHeader('provider')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '12%' }}>Proveedor</th>
                            <th {...this.sortableHeader('stock')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Stock</th>
                            <th aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Stock total</th>
                            <th tabIndex="0" aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1">Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                {this.createModals()}

                {/* Un solo modal para toda la grilla: se le pasa el producto de la fila. Al
                    guardar recarga la página actual (el stock que muestra la grilla cambió) en vez
                    de navegar: navegar desde un modal de Bootstrap deja el backdrop pegado. */}
                <StockAdjustModal
                    show={this.state.adjusting != null}
                    product={this.state.adjusting}
                    onClose={() => this.setState({ adjusting: null })}
                    onDone={() => {
                        this.setState({ adjusting: null });
                        this.fetchData({ showLoader: false });
                    }}
                />

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableProductsComponent;
